//no hash with this guy so its pretty easy.
//just need to dynamically grab the name

//prepend "marvel" to any character thats searched, just so like 'Ajax' returns the character 
//and not JS tutorials or cleaning ads
//use the plus sign bc that seems to be how google handles spaces in its testing docs
export function buildVideoQuery(searchedCharacter){
    var maxResults = 30;
    var marvelPlusName = "marvel+" + searchedCharacter;
    const videoQuery = "https://www.googleapis.com/youtube/v3/search?part=snippet&maxResults=" + maxResults  + "&q=" + marvelPlusName + "&type=video&key=AIzaSyAC2--FyC2IgTz6xePG1xJo0Arxa9vfu04";
    return videoQuery;
}


// WEBPACK FOOTER //
// ./src/components/includes/buildVideoQuery.js